export interface HistoryItemInterface {
  listingId?: string;
  agentId?: string;
  officeId?: string;
  detailUrl?: string;
  fromFavouritesPage?: boolean;
  fromSearchAgentPage?: boolean;
  fromSearchOfficePage?: boolean;
  fromNeighbourhoodPage?: boolean;
}

// Keeps track of a main type of page previously visisted so that the on-page "back to" button knows where to go.
export class HistoryItem {
  translateValue: string = 'navigation.search';
  returnUrl: string[]  = [];
  returnQueryParams: { [key: string]: any } = {};

  // TODO: change fromSearchAgent and fromSearchOffice to just one when we combine the search pages
  constructor(item: HistoryItemInterface = {}) {
    // Build the text and url for the back button
    this.returnUrl = ['/find-real-estate'];

    if (item.agentId) {
      this.translateValue = 'navigation.agent';
      this.returnUrl = [item.detailUrl];
    }
    else if (item.officeId) {
      // TODO: update with the new office stuff
      this.translateValue = 'navigation.office';
      this.returnUrl = [item.detailUrl];
/*
    // TODO: What teamId will be passed into the LDP page so we know which team page to go back to?
    } else if (this.activeViewMode === ViewModes.TEAM) {
      this.translateValue = 'navigation.team';
      this.returnUrl = ['/team-profile'] // TODO: Pass in a teamId or something
    }
*/
    }
    else if (item.listingId) {
      this.translateValue = 'navigation.listing';
      this.returnUrl = [item.detailUrl];
    }
    else if (item.fromSearchAgentPage) {
      this.returnUrl = ['/find-agent-or-office','agent'];
    }
    else if (item.fromSearchOfficePage) {
      this.returnUrl = ['/find-agent-or-office','office'];
    }
    else if (item.fromFavouritesPage) {
      this.translateValue = 'navigation.saved-listings';
      this.returnUrl = ['/my-remax'];
    }
    else if (item.fromNeighbourhoodPage) {
      this.translateValue = 'navigation.neighbourhood';
      this.returnUrl = [item.detailUrl];
    }
  }
}
